import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../loader/loader";
import NotAuthorized from "../notAuthorized/notAuthorized";
import { validarToken } from "../../API/auth/Auth";

const PrivateRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setIsLoading(true);

      // 1) Tente obter credenciais atuais do storage
      let storedUser = null;
      try {
        storedUser = JSON.parse(sessionStorage.getItem("user") || "null");
      } catch { /* ignore */ }

      // 2) Leia possíveis credenciais vindas por URL
      const queryParams = new URLSearchParams(location.search);
      const qpUser = queryParams.get("user");
      const qpCondominio = queryParams.get("condominio");
      const qpToken = queryParams.get("token");

      // 3) Decida qual token usar: prioridade para o da URL
      const tokenToValidate = qpToken ?? storedUser?.token ?? null;

      if (!tokenToValidate) {
        if (!cancelled) {
          setIsAuthorized(false);
          setIsLoading(false);
        }
        return;
      }

      try {
        // 4) Valide o token (nova assinatura: string ou undefined)
        const res = await validarToken(tokenToValidate);

        // Se seu `api` retorna { ok, data, status }:
        const ok = res?.ok ?? (res?.status >= 200 && res?.status < 300);

        if (!ok) {
          throw res?.error || new Error("Token inválido");
        }

        // 5) Se veio pela URL, persista (e opcionalmente complemente com user/condominio)
        if (qpToken) {
          const payloadToStore = {
            // mantenha o que já tinha salvo (se fizer sentido)
            ...(storedUser || {}),
            token: qpToken,
            ...(qpUser ? { user: qpUser } : {}),
            ...(qpCondominio ? { condominio: qpCondominio } : {}),
          };
          sessionStorage.setItem("user", JSON.stringify(payloadToStore));

          // Limpa os params da URL
          const newUrl = location.pathname;
          window.history.replaceState({}, document.title, newUrl);
        }

        if (!cancelled) {
          setIsAuthorized(true);
        }
      } catch (err) {
        console.error("Erro na validação do token:", err);
        // Zere qualquer resquício inválido
        sessionStorage.removeItem("user");
        if (!cancelled) {
          setIsAuthorized(false);
          // Se quiser, só redireciona quando já estiver fora de rotas públicas
          navigate("/", { replace: true });
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.search, location.pathname, navigate]);

  if (isLoading) return <Loader />;

  return isAuthorized ? children : <NotAuthorized />;
};

export default PrivateRoute;